import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

import RegistrationForm from "./components/RegistrationForm";
import "./App.css";

const App = () => {
  // The form is visible immediately — reCAPTCHA is verified at submit time
  // instead (see RegistrationForm), not as a gate before the parent can even
  // start filling it in. formKey only bumps after a real successful
  // submission, to get a fresh form + fresh captcha for the next one.
  const [formKey, setFormKey] = useState(0);
  const [showContact, setShowContact] = useState(false);

  const handleSubmitted = () => {
    setFormKey((k) => k + 1);
  };

  useEffect(() => {
    if (!showContact) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setShowContact(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showContact]);

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header-inner container">
          <div className="app-brand">
            <img
              src="/eon-logo.png"
              alt="The Eon Academy"
              className="app-logo"
            />
            <div className="app-brand-text">
              <h1 className="app-title">THE EON ACADEMY</h1>
              <p className="app-tagline">Where Learning Meets Innovation</p>
            </div>
          </div>
          <div className="app-header-actions">
            <button
              type="button"
              className="btn btn-contact"
              onClick={() => setShowContact(true)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              Contact Us
            </button>
          </div>
        </div>
      </header>

      {showContact && (
        <div
          className="contact-modal-backdrop"
          role="dialog"
          aria-modal="true"
          aria-labelledby="contact-title"
          onClick={() => setShowContact(false)}
        >
          <div
            className="contact-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="contact-modal-close"
              aria-label="Close"
              onClick={() => setShowContact(false)}
            >
              &times;
            </button>
            <div className="contact-modal-header">
              <img
                src="/eon-logo.png"
                alt=""
                className="contact-modal-logo"
                aria-hidden="true"
              />
              <h4 id="contact-title" className="mb-0">
                Contact The Eon Academy
              </h4>
              <p className="text-muted small mb-0">
                Get in touch — we're here to help.
              </p>
            </div>

            <ul className="contact-list">
              <li>
                <span className="contact-list-icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </span>
                <div>
                  <div className="contact-list-label">Address</div>
                  <div>Plot # 54, Block-3, Bahadurabad, Karachi, Pakistan</div>
                </div>
              </li>
              <li>
                <span className="contact-list-icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                <div>
                  <div className="contact-list-label">Phone</div>
                  <a href="tel:+922134912345">+92 21 3491 2345</a>
                </div>
              </li>
              <li>
                <span className="contact-list-icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                <div>
                  <div className="contact-list-label">Email</div>
                  <a href="mailto:info@eon.edu.pk">info@eon.edu.pk</a>
                </div>
              </li>
              <li>
                <span className="contact-list-icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </span>
                <div>
                  <div className="contact-list-label">Office Hours</div>
                  <div>Mon – Fri, 8:00 AM – 4:00 PM</div>
                </div>
              </li>
            </ul>

            <button
              type="button"
              className="btn btn-primary w-100 mt-2"
              onClick={() => setShowContact(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <section className="app-hero">
        <div className="container">
          <h2 className="app-hero-title">Student Registration</h2>
          <p className="app-hero-sub">
            Parents — please complete this form to register your child for
            admission at The Eon Academy.
          </p>
        </div>
      </section>

      <main className="container app-main">
        <RegistrationForm key={formKey} onSubmitted={handleSubmitted} />
      </main>

      <footer className="app-footer">
        <div className="container">
          <p className="mb-0">
            &copy; {new Date().getFullYear()} The Eon Academy. All rights
            reserved.
          </p>
          <p className="mb-0 small text-muted">
            Plot # 54, Block-3, Bahadurabad, Karachi, Pakistan
          </p>
        </div>
      </footer>

      <ToastContainer position="top-right" autoClose={4000} />
    </div>
  );
};

export default App;
